import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';

export const InformationStockopname = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['StockOpname.Show']
  );

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3" id="order">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Detail'
        )}
      </div>
      <div className="row pt-2">
        {StateLoading ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <ListHorizontal
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            </div>
          ))
        ) : (
          <>
            <div className="col-md-6 col-12">
              <ListHorizontal title="Kode" content={data?.code} />
              <ListHorizontal
                title="Tipe"
                content={
                  <div
                    className={cn(
                      'badge ms-auto',
                      data?.type === 'opname' ? 'bg-primary-lt' : 'bg-yellow-lt'
                    )}
                  >
                    {data?.type}
                  </div>
                }
              />
              <ListHorizontal
                title="Warehouse"
                content={data?.warehouse?.name}
              />
              <ListHorizontal
                title="Catatan"
                className="border-bottom-0"
                content={data?.note || '-'}
              />
            </div>
            <div className="col-md-6 col-12">
              <ListHorizontal title="Dibuat Oleh" content={data?.created_by} />
              <ListHorizontal
                title="Dibuat Pada"
                content={formatDate(data?.created_at, 'DD/MM/YYYY')}
              />

              {data?.completed_by && (
                <>
                  <ListHorizontal
                    title="Diselesaikan Oleh"
                    content={data?.completed_by}
                  />
                  <ListHorizontal
                    title="Tanggal Selesai"
                    className="border-bottom-0"
                    content={formatDate(data?.completed_at, 'DD/MM/YYYY')}
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );
};
